"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DownloadIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "24",
  height: "23",
  viewBox: "0 0 24 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-303.000000, -126.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(303.000000, 127.000000)",
        fill: color,
        fillRule: "nonzero",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M22.9904187,13.8534258 C22.996735,13.8984499 23,13.9444417 23,13.9911894 L23,21.0088106 C23,21.5562294 22.5522847,22 22,22 L1,21.9990088 C0.44771525,21.9990088 1.42108547e-14,21.5552382 1.42108547e-14,21.0078194 L1.42108547e-14,13.9911894 C1.42108547e-14,13.8644372 0.024003445,13.7432419 0.0677505651,13.6318258 C0.0331386944,13.3700143 0.102206238,13.0973075 0.274354519,12.8799877 L0.358390602,12.7865356 L3.4130781,9.78653555 C3.80711364,9.39955436 4.44025279,9.40527304 4.82723398,9.79930857 C5.18444739,10.1630337 5.20705262,10.7304921 4.89849704,11.1200123 L4.81446096,11.2134644 L2.99535836,13 L7.5,13 C8.05228475,13 8.5,13.4437706 8.5,13.9911894 L8.5,15.3927313 L14.5,15.3927313 L14.5,13.9911894 C14.5,13.4437706 14.9477153,13 15.5,13 L20.1184114,13 L18.2993088,11.2134644 L18.2152727,11.1200123 C17.9067172,10.7304921 17.9293224,10.1630337 18.2865358,9.79930857 C18.673517,9.40527304 19.3066561,9.39955436 19.7006917,9.78653555 L22.7553792,12.7865356 L22.8394153,12.8799877 C23.061071,13.1598056 23.1118314,13.5314483 22.9904187,13.8534258 Z M21,15 L16.5,15 L16.5,15.3927313 C16.5,16.4470931 15.6841222,17.3108964 14.6492623,17.3872455 L14.5,17.3927313 L8.5,17.3927313 C7.4456382,17.3927313 6.58183488,16.5768535 6.50548574,15.5419936 L6.5,15.3927313 L6.5,15 L2,15 L2,19.999 L21,20 L21,15 Z M10.5,8.6495894 L10.5,1.50990331e-14 C10.5,-0.55228475 10.9477153,-1 11.5,-1 C12.0128358,-1 12.4355072,-0.61395981 12.4932723,-0.116621125 L12.5,1.50990331e-14 L12.5,8.63050922 L15.3107568,5.95512549 C15.6801241,5.60374933 16.2478705,5.59018317 16.6324279,5.90490235 L16.72453,5.99041591 C17.0759061,6.35978317 17.0894723,6.92752955 16.7747531,7.31208698 L16.6892396,7.40418908 L12.1476875,11.7245317 C11.7865351,12.0680932 11.2338196,12.0897022 10.8486218,11.7926552 L10.7560201,11.7117567 L6.29757218,7.31175666 C5.90447976,6.92381749 5.90030224,6.29066629 6.28824141,5.89757388 C6.64633911,5.53471935 7.21337487,5.50324792 7.60767004,5.80567789 L7.70242419,5.88824312 L10.5,8.6495894 Z"
        })
      })
    })
  })]
});

DownloadIcon.defaultProps = {
  color: 'currentColor'
};
var _default = DownloadIcon;
exports.default = _default;